// Translates rendered store-app UI text in place using the fixed phrase table (English text -> [gu, hi, pa, pl, ro, ur]).
const ORDER = ["gu", "hi", "pa", "pl", "ro", "ur"];
const ATTRS = ["placeholder", "title", "aria-label"];
const SKIP = new Set(["SCRIPT", "STYLE", "TEXTAREA", "INPUT", "CODE", "NOSCRIPT"]);
let phrases = null;
let lang = "en";
let observer = null;

const lookup = (en) => {
  if (lang === "en" || !phrases || window.location.pathname.startsWith("/admin")) return en;
  const m = en.match(/^(\s*)([\s\S]*?)(\s*)$/);
  const hit = phrases[m[2]];
  return hit ? m[1] + (hit[ORDER.indexOf(lang)] || m[2]) + m[3] : en;
};

const skipped = (el) => !el || SKIP.has(el.tagName) || el.closest?.("[data-no-translate]");

const doText = (n) => {
  if (skipped(n.parentElement)) return;
  if (n.nodeValue !== n.__zbLast) n.__zbOrig = n.nodeValue;
  const out = lookup(n.__zbOrig);
  n.__zbLast = out;
  if (n.nodeValue !== out) n.nodeValue = out;
};

const doAttrs = (el) => {
  if (el.closest("[data-no-translate]")) return;
  for (const a of ATTRS) {
    const v = el.getAttribute(a);
    if (v == null) continue;
    if (v !== el[`__zbLast_${a}`]) el[`__zbOrig_${a}`] = v;
    const out = lookup(el[`__zbOrig_${a}`]);
    el[`__zbLast_${a}`] = out;
    if (v !== out) el.setAttribute(a, out);
  }
};

const walk = (root) => {
  if (root.nodeType === 3) return doText(root);
  if (root.nodeType !== 1 || skipped(root)) return;
  doAttrs(root);
  const tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
  let n = tw.nextNode();
  while (n) { if (n.nodeType === 3) doText(n); else doAttrs(n); n = tw.nextNode(); }
};

export const applyDomLanguage = async (next) => {
  lang = next;
  if (lang !== "en" && !phrases) phrases = (await import("./i18n-phrases.json")).default;
  if (!observer) {
    observer = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === "characterData") doText(m.target);
        else if (m.type === "attributes") doAttrs(m.target);
        else m.addedNodes.forEach(walk);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  }
  walk(document.body);
};
